/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  // Check if printer has been set or not
  if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0); // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var printMyText = function printMyText() {
    var printText = "";
    var print80Line = "";
    if (localStorage.getItem("paperSize") == 1) print80Line = "______________";
    if (window.origin == "claim") printText += "{CENTER}{BR}{H}CLAIM RECEIPT{/H}{BR}{BR}";
    if (window.origin == "claimjackpot") printText += "{CENTER}{BR}{H}CLAIM JACKPOT RECEIPT{/H}{BR}{BR}";
    printText += "Order ID:{BR}" + window.data.orderID + "{BR}";
    printText += "Date :{BR}" + window.data.dateClaimed + "{BR}";
    if (window.data.claimStatus == "1") printText += "COPY{BR}";
    printText += print80Line + "_______________________________";
    printText += "{BR}{BR}";
    printText += "{LEFT}Please fill in customer detail{BR}{BR}";
    if (window.data.claimName != "") printText += "{BR}{BR}Name      :" + window.data.claimName + "{BR}{BR}";else printText += "{BR}{BR}Name      :_____________________{BR}{BR}";
    if (window.data.claimIC != "") printText += "{BR}{BR}IC        :" + window.data.claimIC + "{BR}{BR}";else printText += "{BR}{BR}IC        :_____________________{BR}{BR}";
    printText += "{BR}{BR}GDPoints ID/                    ";
    if (window.data.smsnum != "") printText += "{BR}{BR}Mobile No :" + window.data.smsnum + "{BR}{BR}{BR}{BR}";else printText += "{BR}{BR}Mobile No :_____________________{BR}{BR}{BR}{BR}";
    printText += "{BR}{BR}Sign      :_____________________{BR}{BR}";
    printText += "{BR}{BR}{BR}";

    for (var i = 0; i < window.data.strikes.length; i++) {
      var strike = window.data.strikes[i];
      printText += "{BR}" + strike.drawDate + ", " + strike.betPosition + " " + strike.number + ", " + strike.prize;
    }

    printText += "{BR}{BR}{BR}Total Prize Won: " + window.data.gross;
    printText += "{BR}Total Winning Tax (10%): " + window.data.tax;
    printText += "{BR}Total Net Payout: " + window.data.total;
    printText += "{BR}{BR}{H}{CENTER}TOTAL  : $" + window.data.total + "{BR}{BR}{CENTER}";
    window.DatecsPrinter.printText(printText, 'ISO-8859-1');
    printMyBarcode(window.data.orderID);
  };

  var printMyImage = function printMyImage() {
    var image = new Image();
    image.src = 'static/images/gd.jpg';

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 100;
      canvas.width = 100;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyQR();
      });
    };
  };

  var printMyQR2 = function printMyQR2() {
    var qrcodejs = new QRCode("qrcode", {
      text: window.orderEntry,
      width: 150,
      height: 150,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    });

    var imageData = qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg").replace(/^data:image\/(png|jpg|jpeg);base64,/, "");

    console.log(qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg"));
    window.DatecsPrinter.printImage(imageData, //base64
    150, 150, 1, function () {
      printMyText();
    });
  };

  var printMyBarcode = function printMyBarcode(text) {
    var canvas = document.createElement("canvas");
    canvas.height = 400;
    canvas.width = 300;
    JsBarcode(canvas, text, {
      format: "CODE128",
      width: 2
    });
    var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    window.DatecsPrinter.printImage(imageData, //base64
    canvas.width, canvas.height, 1, function () {
      window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      if (localStorage.getItem("printerName") == "Printer001") window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      window.DatecsPrinter.writeHex('1B69');
    });
  };

  var printPurchase = function printPurchase() {
    if (!window.DatecsPrinter) {
      alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
    } else {
      window.bluetooth = localStorage.getItem("printer");
      if (window.bluetooth == null || window.bluetooth == undefined) window.bluetooth = 0;
      window.DatecsPrinter.listBluetoothDevices(function (devices) {
        localStorage.setItem("printerName", devices[window.bluetooth].name);
        window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {
          printMyText();
        }, function () {
          if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
          alert(JSON.stringify(error));
        });
      }, function (error) {
        if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
        alert(JSON.stringify(error));
      });
    }
  };

  $on('pageAfterIn', function () {
    $f7.toolbar.hide(".toolbar-app");
  });
  $on('pageAfterOut', function () {
    $f7.toolbar.show(".toolbar-app");
  });
  $on('pageInit', function () {
    if (window.isPrint != true) return;
    window.isPrint = false;
    $('.button-cancel').hide();
    printPreview();
  });

  var printCancel = function printCancel() {
    if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
  };

  var printPreview = function printPreview() {
    var orderId = window.orderId;
    $f7.request({
      method: 'get',
      url: window.waypoint + 'strikeStatus.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderId: orderId
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        $f7.preloader.hide();
        console.log("THIS IS THE DATA:" + data);
        var data = JSON.parse(data);
        var htmlText = '';
        window.data = data;

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          if (data.claimStatus == "0") {
            $(".button-print").html("Print");
          } else {
            $(".button-print").html("Print Copy");
          }

          htmlText = "\n                <div class=\"block\">\n                  Print the receipt to collect the winning prize\n                </div>\n                <div class=\"card data-table\">\n                  <table>\n                    <thead>\n                      <tr>\n                        <th class=\"label-cell\">Type</th>\n                        <th class=\"numeric-cell\">Description</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td class=\"label-cell\">Order ID</td>\n                        <td class=\"numeric-cell\" style=\"font-size:22px; weight: bold;\">" + data.orderID + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Date Claimed</td>\n                        <td class=\"numeric-cell\">" + data.dateClaimed + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Name</td>\n                        <td class=\"numeric-cell\">" + data.claimName + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">IC</td>\n                        <td class=\"numeric-cell\">" + data.claimIC + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Mobile No</td>\n                        <td class=\"numeric-cell\">" + data.smsnum + "</td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  <div class=\"data-table-footer\">\n                    <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n                  </div>\n                </div>\n              ";
          $('.printtext').html(htmlText);
          $update();
        } else {
          $f7.dialog.alert('Order Not Found', function () {
            if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
          });
        }
      },
      error: function error(data) {
        $f7.dialog.alert('Something wrong, data cannot be retrieved...', function () {
          if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
        });
        $f7.preloader.hide();
      }
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="kiosk_receipt_winning">

  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="title title-claim">
        <span class='en'>Claim Receipt</span>
        <span class='cn'>索赔收据</span>
        <span class='tl'>Reklema Resibu</span>
      </div>
    </div>
  </div>

  <div class="fab fab-extended fab-right-bottom color-teal">
    <a href="#" @click=${printPurchase}>
      <i class="icon f7-icons">printer</i>
      <div class="fab-text button-print" style="font-size: 18px;">Print</div>
    </a>
  </div>
  
  <div class="page-content">

    <div class="printtext">

    </div>



    <div class="fab fab-extended fab-left-bottom button-cancel" style="color:var(--f7-theme-color)">
      <a href="#" @click=${printCancel}>
        <i class="icon f7-icons">multiply</i>
        <div class="fab-text" style="font-size: 18px;">
          <span class='en'>Cancel</span>
          <span class='cn'>取消</span>
          <span class='tl'>Kansela</span>
        </div>
      </a>
    </div>
    
    <div class="block" style="display: none;">
      <div style="text-align: center;">
        <div id="qrcode" style="display:none;"></div>
        <img id="barcode"/>
      </div>
    
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '837c954732';
export default framework7Component;